var _circle, _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagSenDestination(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#F1F1FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7644_78231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 92,
    height: 92
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 101C80.4051 101 101 80.4051 101 55C101 29.5949 80.4051 9 55 9C29.5949 9 9 29.5949 9 55C9 80.4051 29.5949 101 55 101Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7644_78231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6117 8.2207H-15.168V101.777H31.6117V8.2207Z",
    fill: "#00853F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.391 8.2207H31.6113V101.777H78.391V8.2207Z",
    fill: "#FDEF42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.168 8.2207H78.3887V101.777H125.168V8.2207Z",
    fill: "#E31B23"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7644_78231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 92,
    height: 92
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101C80.4051 101 101 80.4051 101 55C101 29.5949 80.4051 9 55 9C29.5949 9 9 29.5949 9 55C9 80.4051 29.5949 101 55 101Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7644_78231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6747 56.9035L69.8117 50.2549H58.5073L55 39.4966L51.4927 50.2549H40.1855L49.3253 56.9035L45.8011 67.7209L55 61.0301L64.1989 67.7209L60.6747 56.9035Z",
    fill: "#00853F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSenDestination);
export default __webpack_public_path__ + "static/media/flagSENDestination.be189666d2087ea705432b1392789062.svg";
export { ForwardRef as ReactComponent };